import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import EditTeamDetails from '../../EditTeamDetails/EditTeamDetails';
import { getTeamDetails } from '../../../redux/selectors/teamDetails';
import { connect, ConnectedProps } from 'react-redux';
import { setTeamDetails } from '../../../redux/actions/serverApi.actions';
import { TeamDetailsState } from '../../../redux/configure-store';
import { generateLearnMoreLink } from '../../../consts/external-links';
import { validateTeamName } from '../../../services/validators';
import * as css from './EditTeamModal.scss';
import { getLocale } from '../../../redux/selectors/config';
import { MessageBoxFunctionalLayout } from 'wix-style-react';

interface Props extends InjectedTranslateProps, ConnectedProps<typeof connector> {
  closeModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface State {
  teamDetails: TeamDetailsState;
  isValid: boolean;
  errorMessage?: string;
  isUploading: boolean;
}

class EditTeamModal extends React.PureComponent<Props, State> {
  private nameInput;

  constructor(props) {
    super(props);
    const { teamDetails } = this.props;
    this.state = { teamDetails, isValid: true, isUploading: false };
  }

  validate(name: string) {
    const validationResult = validateTeamName(name);
    this.setState(validationResult);
  }

  render() {
    const { closeModal, onSave, t, locale } = this.props;
    const { isUploading } = this.state;
    return (
      <MessageBoxFunctionalLayout
        cancelText={t('teamDetailsModal.cancel')}
        confirmText={t('teamDetailsModal.save')}
        dataHook="edit-team-modal"
        disableConfirmation={isUploading}
        onCancel={closeModal}
        buttonsHeight="small"
        noBodyPadding
        onOk={() => {
          this.validate(this.state.teamDetails && this.state.teamDetails.name);
          if (this.state.isValid) {
            onSave(this.state.teamDetails);
            closeModal(undefined);
          } else {
            this.nameInput && this.nameInput.focus();
          }
        }}
        theme="blue"
        title={t('teamDetails.editTeamNameAndLogo')}
        width="498px"
      >
        <div className={css.wrapper}>
          <EditTeamDetails
            onUpdateDetails={(teamDetails: TeamDetailsState) =>
              this.setState({ teamDetails })
            }
            onUpdateUploadStatus={(_isUploading: boolean) =>
              this.setState({ isUploading: _isUploading })
            }
            validate={name => this.validate(name)}
            isValid={this.state.isValid}
            errorMessage={this.state.errorMessage}
            extractRef={ref => (this.nameInput = ref)}
            learnMoreLink={generateLearnMoreLink(locale)}
          />
        </div>
      </MessageBoxFunctionalLayout>
    );
  }
}

const mapStateToProps = state => {
  return {
    teamDetails: getTeamDetails(state),
    locale: getLocale(state),
  };
};

const connector = connect(mapStateToProps, {
  onSave: (teamDetails: TeamDetailsState) => setTeamDetails(teamDetails, true),
});
export default connector(translate()(EditTeamModal));
